import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@tremor/react';
import { Pill } from 'evergreen-ui';
import { useQuery } from 'react-query';
import { FindCandidates } from './components/FindCandidates';
import { ResumeManagment } from './components/ResumeManagment/ResumeManagment';
import { YourVacancies } from './components/YourVacancies';
import { Dashboard } from './components/Dashboard/Dashboard';
import { Pipeline } from './components/Pipeline/Pipeline';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { CalendarRoute } from './components/Calendar';
import { getAtsSummary } from '../../network/ats';
import { CareersPageCard } from './components/CareersPage/CareersPageCard';

// One tab per panel, in the same order.
const jobTabs = [
  { name: 'Vacancies', key: 'vacancies' },
  { name: 'Pipeline', key: 'pipeline' },
  { name: 'Find Candidate', key: 'candidates', showCount: true },
  { name: 'Resume management', key: 'resumes' },
  { name: 'Calendar', key: 'calendar' },
  { name: 'Dashboard', key: 'dashboard' },
];

export const JobRoute = () => {
  const { data: summary } = useQuery({
    queryKey: ['ats-summary'],
    queryFn: getAtsSummary,
  });
  const candidateCount = summary?.totals?.candidates;

  return (
    <div>
      <CareersPageCard />
      <TabGroup defaultIndex={0}>
        <TabList variant="line" color="red-500" className="mb-6 overflow-x-auto">
          {jobTabs.map((tab) => (
            <Tab key={tab.key}>
              {tab.name}
              {tab.showCount && typeof candidateCount === 'number' && (
                <Pill
                  className="text-xs font-medium"
                  marginLeft={4}
                  marginBottom={2}
                  color="green"
                >
                  {candidateCount}
                </Pill>
              )}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          <TabPanel>
            <YourVacancies />
          </TabPanel>
          <TabPanel>
            <Pipeline />
          </TabPanel>
          <TabPanel>
            <FindCandidates />
          </TabPanel>
          <TabPanel>
            <ResumeManagment />
          </TabPanel>
          <TabPanel>
            <div className="h-[95vh]">
              <CalendarRoute />
            </div>
          </TabPanel>
          <TabPanel>
            <Dashboard />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  );
};
